import { createFileRoute } from "@tanstack/react-router";
import { PeriodicNotificationPage } from "@/features/user-setting/components/PeriodicNotificationPage";

export const Route = createFileRoute("/settings/periodic-notification")({
  component: PeriodicNotificationPage,
});
